module.exports = __webpack_public_path__ + "img/pdf.ed41a29f.svg";